// src/components/ExamNav.jsx
// Wspólna nawigacja stron z pytaniami egzaminacyjnymi:
// okruszki, przejście poprzednia/następna część oraz CTA do testów.
import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../css/modules/ExamNav.module.css';
import JsonLd from '../seo/JsonLd';
import { EXAM_PAGES, getExamPageIndex, breadcrumbJsonLd, getLowestPrice } from '../seo/siteMeta';
import { trackEvent } from '../lib/analytics';

export const ExamBreadcrumbs = ({ current }) => {
  const idx = getExamPageIndex(current);
  const page = EXAM_PAGES[idx];
  if (!page) return null;

  return (
    <>
      <JsonLd
        data={breadcrumbJsonLd([
          { name: 'Strona główna', path: '/' },
          { name: 'Patent strzelecki', path: '/patent-strzelecki' },
          { name: page.label, path: page.path },
        ])}
      />
      <nav className={styles.breadcrumbs} aria-label="Ścieżka nawigacji">
        <Link to="/">Strona główna</Link> ›{' '}
        <Link to="/patent-strzelecki">Patent strzelecki</Link> › <span>{page.label}</span>
      </nav>
    </>
  );
};

const ExamNav = ({ current }) => {
  const idx = getExamPageIndex(current);
  const prev = idx > 0 ? EXAM_PAGES[idx - 1] : null;
  const next = idx >= 0 && idx < EXAM_PAGES.length - 1 ? EXAM_PAGES[idx + 1] : null;
  const lowestPrice = getLowestPrice();

  return (
    <div className={styles.wrap}>
      <div className={styles.ctaBox}>
        <h2>Samo czytanie nie wystarczy</h2>
        <p>
          Pytania zapamiętasz dopiero wtedy, gdy zaczniesz je rozwiązywać. Sprawdź się
          w darmowym teście, a potem przerób pełną bazę pytań w trybie egzaminu.
        </p>
        <div className={styles.ctaRow}>
          <Link
            to="/intro"
            className={styles.primaryButton}
            onClick={() => trackEvent('cta_click', { location: 'exam_page', label: 'demo' })}
          >
            Rozwiąż darmowy test
          </Link>
          <Link
            to="/cennik"
            className={styles.secondaryButton}
            onClick={() => trackEvent('cta_click', { location: 'exam_page', label: 'cennik' })}
          >
            Pełny dostęp od {lowestPrice} zł
          </Link>
        </div>
      </div>

      <nav className={styles.pager} aria-label="Kolejne zestawy pytań">
        {prev ? (
          <Link to={prev.path} className={styles.pagerLink}>
            <span className={styles.pagerLabel}>← Poprzedni zestaw</span>
            <span className={styles.pagerTitle}>{prev.label}</span>
          </Link>
        ) : (
          <span />
        )}
        {next ? (
          <Link to={next.path} className={`${styles.pagerLink} ${styles.pagerNext}`}>
            <span className={styles.pagerLabel}>Następny zestaw →</span>
            <span className={styles.pagerTitle}>{next.label}</span>
          </Link>
        ) : (
          <Link to="/patent-strzelecki" className={`${styles.pagerLink} ${styles.pagerNext}`}>
            <span className={styles.pagerLabel}>Podsumowanie →</span>
            <span className={styles.pagerTitle}>Patent strzelecki krok po kroku</span>
          </Link>
        )}
      </nav>

      <section className={styles.allSets}>
        <h2>Wszystkie zestawy pytań egzaminacyjnych</h2>
        <ul>
          {EXAM_PAGES.map(page => (
            <li key={page.path}>
              {page.path === current ? (
                <span className={styles.currentSet}>{page.label}</span>
              ) : (
                <Link to={page.path}>{page.label}</Link>
              )}
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
};

export default ExamNav;
